<agc-form [formGroup]="form" (submit)="submit()">
  <div class="row m-b-20">
    <div class="col-md-12">
      <h3 class="text-center">User Sign In</h3>
    </div>
  </div>

  <agc-form-field>
    <input type="text" formControlName="email" autocomplete="username" class="form-control" required placeholder="Your Username or Email Address">
  </agc-form-field>

  <agc-form-field>
    <input type="password" formControlName="password" autocomplete="current-password" class="form-control" required placeholder="Password">
  </agc-form-field>

  <div class="row m-t-25 text-left">
    <div class="col-12">
      <div class="checkbox-fade fade-in-primary d-">
        <label>
          <input type="checkbox" value="">
          <span class="cr"><i class="cr-icon icofont icofont-ui-check txt-primary"></i></span>
          <span class="text-inverse">Remember me</span>
        </label>
      </div>
      <div class="forgot-phone text-right f-right">
        <a [routerLink]="['/forgot-password']" class="text-right f-w-600"> Forgot Password?</a>
      </div>
    </div>
  </div>
  <div class="row m-t-30">
    <div class="col-md-12">
      <button type="submit" class="btn btn-primary btn-md btn-block waves-effect waves-light text-center m-b-20">Sign in</button>
    </div>
  </div>
  <hr>
  <p class="text-inverse text-center m-b-0">
    Not yet registered? <a [routerLink]="['/signup']"><b class="f-w-600">Sign Up</b></a>
  </p>
</agc-form>
